export default {
  // Page metadata
  'meta.title': 'Conditions d\'Utilisation - timer.today',
  'meta.description': 'Conditions d\'utilisation et accord d\'utilisation pour la plateforme d\'outils de chronométrage en ligne timer.today. Découvrez nos règles de service, droits et responsabilités des utilisateurs.',

  // Page header
  'page.title': 'Conditions d\'Utilisation',
  'page.lastUpdated': 'Dernière mise à jour : {{date}}',
  'page.intro': 'Bienvenue sur timer.today. Ces conditions générales décrivent les règles et réglementations pour l\'utilisation du site Web de timer.today, situé à timer.today.',

  // Section 1
  'section1.title': '1. Acceptation des Conditions',
  'section1.content': 'En accédant et en utilisant ce site Web, vous acceptez et convenez d\'être lié par les termes et dispositions de cet accord. Si vous n\'acceptez pas de respecter ce qui précède, veuillez ne pas utiliser ce service.',

  // Section 2
  'section2.title': '2. Description du Service',
  'section2.intro': 'timer.today fournit des outils de chronométrage en ligne gratuits comprenant :',
  'section2.timer': 'Minuteur Inversé - Minuteur personnalisable pour la productivité, la cuisine et la gestion du temps',
  'section2.stopwatch': 'Chronomètre - Outil de chronométrage haute précision pour le sport, l\'entraînement et le chronométrage précis',
  'section2.worldclock': 'Horloge Mondiale - Affichage en temps réel des fuseaux horaires mondiaux',

  // Section 3
  'section3.title': '3. Licence d\'Utilisation',
  'section3.intro': 'L\'autorisation est accordée d\'utiliser temporairement timer.today pour une consultation transitoire personnelle et non commerciale uniquement. Il s\'agit de l\'octroi d\'une licence, et non d\'un transfert de titre, et sous cette licence vous ne pouvez pas :',
  'section3.item1': 'modifier ou copier les matériaux',
  'section3.item2': 'utiliser les matériaux à des fins commerciales ou pour tout affichage public',
  'section3.item3': 'tenter de procéder à l\'ingénierie inverse de tout logiciel contenu sur le site Web',
  'section3.item4': 'supprimer tout droit d\'auteur ou autres notations de propriété des matériaux',

  // Section 4
  'section4.title': '4. Confidentialité et Données',
  'section4.intro': 'timer.today s\'engage à protéger votre vie privée :',
  'section4.item1': 'Nous ne collectons ni ne stockons d\'informations personnelles',
  'section4.item2': 'Les paramètres du minuteur sont stockés localement dans votre navigateur',
  'section4.item3': 'Nous ne suivons pas le comportement ou les modèles d\'utilisation des utilisateurs',
  'section4.item4': 'Aucun cookie n\'est utilisé à des fins de suivi',

  // Section 5
  'section5.title': '5. Clause de Non-Responsabilité',
  'section5.content': 'Les matériaux sur timer.today sont fournis sur une base « tels quels ». timer.today ne donne aucune garantie, expresse ou implicite, et décline et nie par la présente toutes les autres garanties, y compris, sans limitation, les garanties ou conditions implicites de qualité marchande, d\'adéquation à un usage particulier ou de non-violation de la propriété intellectuelle ou d\'autre violation de droits.',

  // Section 6
  'section6.title': '6. Limitations',
  'section6.content': 'En aucun cas timer.today ou ses fournisseurs ne seront responsables de tout dommage (y compris, sans limitation, les dommages pour perte de données ou de profit, ou dus à une interruption d\'activité) découlant de l\'utilisation ou de l\'impossibilité d\'utiliser les matériaux sur timer.today, même si timer.today ou son représentant autorisé a été informé oralement ou par écrit de la possibilité de tels dommages.',

  // Section 7
  'section7.title': '7. Exactitude des Matériaux',
  'section7.content': 'Les matériaux apparaissant sur timer.today peuvent inclure des erreurs techniques, typographiques ou photographiques. timer.today ne garantit pas que l\'un des matériaux sur son site Web est exact, complet ou actuel. timer.today peut apporter des modifications aux matériaux contenus sur son site Web à tout moment sans préavis.',

  // Section 8
  'section8.title': '8. Modifications',
  'section8.content': 'timer.today peut réviser ces conditions d\'utilisation de son site Web à tout moment sans préavis. En utilisant ce site Web, vous acceptez d\'être lié par la version actuelle de ces conditions d\'utilisation.',

  // Section 9
  'section9.title': '9. Informations de Contact',
  'section9.intro': 'Si vous avez des questions concernant ces Conditions d\'Utilisation, veuillez nous contacter à :',
  'section9.email': 'E-mail :',
  'section9.emailSubject': 'Demande de Renseignements sur les Conditions d\'Utilisation - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. Tous droits réservés.'
};
